<template>
	<div class="d-flex align-items-stretch h-100 flex-2">
		<leftnav></leftnav>
		<router-view></router-view>
		<searchPermit/>
	</div>
</template>

<script>

import leftnav from '../left-nav';
import searchPermit from '../search/search-permit';

export default {
	name: 'permits',

	components:{
		searchPermit,
		leftnav
	}
}

</script>


// WEBPACK FOOTER //
// src/components/permit/permit.vue